"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SemVer = require("semver");
class Version {
    constructor(rawVersion) {
        this.rawVersion = rawVersion;
        this.semVer = new SemVer.SemVer(SemVer.coerce(this.rawVersion) || this.rawVersion, true);
    }
    isGreaterThan(anotherVersion) {
        return SemVer.gt(this.semVer, anotherVersion);
    }
    satisfies(ranger) {
        return SemVer.satisfies(this.semVer, ranger);
    }
    get major() {
        return this.semVer.major;
    }
    get minor() {
        return this.semVer.minor;
    }
    get patch() {
        return this.semVer.patch;
    }
}
exports.Version = Version;
//# sourceMappingURL=Version.js.map